<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @save="save"  ref="SetBtn"></buttonlist>
        <!-- 功能按钮 -->
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="VENGWIDLUSER"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleCurrentChanges="handleCurrentChanges"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :row-class-name="tableRowClassName"
                        :checkflg="false"
                        ref="singleTable"
                ></wTable>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                
                <div style="width:950px">
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[876]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.item_id" type="text" 
                                :readonly="true" v-if="false" ></el-input>
                                <routejump :urlNo="5" v-if="addoredit == 1">
                                <el-input
                                    v-model="dataDetail.Head.item_code"
                                    type="text"
                                    readonly
                                    size="mini"
                                    class="mcolor"
                                    style="width: 150px"
                                >   
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItem()"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.Head.item_code" v-if="addoredit != 1" :readonly="true" class="readO"
                                              size="mini"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[546]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.item_name" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[7943]') }}</td>
                            <td style="width:100px;">
                                <el-input :value="dataDetail.Head.item_status" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[6403]') }}</td>
                            <td style="width:150px;">
                                <el-input :value="dataDetail.Head.item_duty_person" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" type="">
                    <el-tab-pane :label="$t('getapi[1066]')" name="0" id="xdetilpane-0">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="showAddUser('')" >{{
                                $t('getapi[438]') }}
                            </el-button>
                            <el-button type="primary" size="mini" :disabled="selectData.length == 0" @click="batchDel">{{
                                $t('getapi[4097]') }}
                            </el-button>
                        </div>                
                        <vxe-table
                                :data="dataDetail.List"
                                @checkbox-change="handleSelectionChange"
                                :row-class-name="tableRowClassNameNot"
                                :highlight-current-row="true"
                                style="width: 100%; 
                                margin-top:1px"
                                :height="tableHeight - 150"
                                resizable
                                show-overflow="tooltip"
                                header-row-class-name="headerclass"
                                size="mini"
                                border
                                @sort-change="sortChange"
                                ref="singleTable1"
                        >
                            <vxe-table-column type="checkbox" width="40" align="center"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="username"
                                                :title="$t('getapi[3226]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="loginname"
                                                :title="$t('getapi[5]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="department"
                                                :title="$t('getapi[8120]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="create_person"
                                                :title="$t('getapi[410]')" sortable align="right" width="100"></vxe-table-column>
                            <vxe-table-column show-footer-overflow field="create_time"
                                                :title="$t('getapi[135]')" sortable align="right" width="100"></vxe-table-column>                      

                            <!-- <vxe-table-column show-overflow-tooltip fixed="right" :title="$t('getapi[6048]')" width="150">
                                <template slot-scope="scope">
                                    <el-popconfirm
                                            :confirmButtonText="$t('getapi[6109]')"
                                            :cancelButtonText="$t('getapi[6]')"
                                            icon="el-icon-info"
                                            iconColor="red"
                                            :title="$t('getapi[637]')"
                                            @onConfirm="del(scope)"
                                    >
                                        <el-button slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                                    </el-popconfirm>
                                </template>
                            </vxe-table-column> -->
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>

        <serce :isVisible="isVisible" queryData="VENGWIDLUSER" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[957]')" queryData="VENGWIDLUSER" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        
        <!--人员-->
        <selector :isVisible="employeeVisible" :isBatch=true :selectType="0" :isSplitPage=true
              :postUrl="'Eng/WIView/GetUserLoginInfoPopuView'" @callback="getemployee" ref="employee"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'Eng/WIView/GetWIItemPopupView'" @callback="getItem" ref="item"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';

    export default {
        name: 'purgrnview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader:[],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('VENGWIDLUSER'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    Head: {
                        item_id: 0,
                        item_code: '',
                        item_name: '',
                        item_status: '',
                        item_duty_person:'',
                    },
                    List: [],
                }, // 编辑页面数据详情
                oldDataDetail: '',
                order_No: '',
                addoredit: -1, // 1.新增2：编辑
                oneormore: -1, // 1:单选2：多选
                rowindex: -1,
                selectData: [],
                itemVisible: false,
                itemAssisVisible: false,
                nowPOCode: 0, // 当前单号
                employeeVisible: false,
                employeeType: 1, //1保管员2记账员
                purcargoVisible: false,
                purcargoType: 1, //1:一般物料2：此物料
                btn: {
                    //审核
                    Audit: false,
                },
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                RightSelectIndex: '0',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
            };
        },
        
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('VENGWIDLUSER', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();
        },
        methods: {
            tableRowClassNameNot({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassName({ row, rowIndex }) {
                row.index = rowIndex;
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('VENGWIDLUSER', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12748]"),this.$t("getapi[18]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            keyup(ev, row) {
                let that = this;
                that.editInfo(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let result = this.dataSet.findIndex(item => item.item_code === val.item_code);
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    this.currentRow = val;
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('VENGWIDLUSER',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'VENGWIDLUSER');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Eng/WIView/GetWIDLIUserView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.order_No == row.item_code){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.List.length;i++){
                        delete datacopy.List[i]['index']
                        delete datacopy.List[i]['_XID'];
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.isShowEdit = true;
                                that.order_No = row.item_code;
                                that.getDetail(row.item_code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.isShowEdit = true;
                        that.order_No = row.item_code;
                        that.getDetail(row.item_code);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(order_No) {
                let that = this;                
                that.addoredit = 2
                if(that.$limits.fnIsEmpty(order_No)){
                    that.$message.warning(that.$t('getapi[8619]'));//单据号不能为空
                    return;
                }
                let parm = {
                    Code: order_No
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Eng/WIView/GetWIDLIUserInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.selectData = [];
                        that.order_No = that.dataDetail.Head.item_code;
                        that.oldDataDetail=JSON.stringify( that.dataDetail);
                        that.authority();
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['index']
                    delete datacopy.List[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let date = Common.methods.getDate();
                that.addoredit = 1;
                that.isShowEdit = true;
                that.dataDetail = {
                    Head: {
                        item_id: 0,
                        item_code: '',
                        item_name: '',
                        item_status: '',
                        item_duty_person:'',
                    },
                    List: [],
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
               
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['index']
                    delete datacopy.List[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit != 1){
                                that.getView();
                                that.getDetail(that.order_No)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit != 1){
                        that.getView();
                        that.getDetail(that.order_No)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },            
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                
                that.$http.urlpost('/Eng/WIView/SaveEngWIDLUser', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.nowPOCode = res.UniqueNum;
                        that.order_No = res.UniqueNum;
                        that.getDetail(that.order_No);
                    }
                });
            },
            // 选择项目信息
            selectItem(){
                let that = this
                that.$refs.item.clearInput(true);
            },
            
            getItem(val){
                let that = this
                console.log(val)
                that.dataDetail.Head.item_code = val.item_code
                that.dataDetail.Head.item_name = val.item_name
                that.dataDetail.Head.item_status= val.item_status
                that.dataDetail.Head.item_id = val.exclusively_id
                that.dataDetail.Head.item_duty_person = val.item_duty_person
            },
            // 新增人员
            showAddUser(row) {
                let that = this;
                if(that.dataDetail.Head.item_code == ''){
                    that.$message.warning(that.$t('getapi[8663]'));//'项目代码不能为空！'
                    return
                }
                that.employeeVisible = true;
                that.$refs.employee.clearInput(that.employeeVisible);                 
            },
            getemployee(data){
                let that = this
                let arr = data.filter(item => {
                    return that.dataDetail.List.every(item2 => {
                        return item.loginName != item2.login_code;
                    });
                });
                data = arr;                
                for(let i=0;i<data.length;i++){
                    that.dataDetail.List = [...that.dataDetail.List,{
                        loginname: data[i].loginName,
                        username: data[i].user_name,
                        department: data[i].cdepnm,
                        remark: ''
                    }]
                }
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[941]')//'审核';
                } else if (val == 2) {
                    return that.$t('getapi[1902]')//'作废';
                } else {
                    return '';
                }
            },    
            // 批量删除
            batchDel() {
                let that = this;
                
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            List: []
                        };
                        console.log("11")
                        console.log(that.selectData)
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            if(that.$limits.fnIsEmpty(that.dataDetail.List[that.selectData[i].index].exclusively_id)){
                                that.dataDetail.List.splice(that.selectData[i].index, 1);
                            }
                            else{
                                let datatmp = {
                                    exclusively_id: that.selectData[i].exclusively_id
                                }
                                parm.List.push(datatmp);
                            }
                        }
                        console.log("22")
                        if (parm.List.length > 0) {
                            // that.btn.rowdel = false
                            that.$http.urlpost('/Eng/WIView/DelENGWIDLUSERByID', parm, function (res) {
                                // that.btn.rowdel = true
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.order_No != '') {
                                        that.getDetail(that.order_No);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },       
            handleSelectionChange({checked, records }) {
                let that = this;
                that.selectData = [];
                that.selectData = records;
                // for (let i = 0; i < records.length; i++) {
                //     that.selectData.push(records[i]);
                // }
                console.log(JSON.stringify( that.selectData))
            },          
            keepAccount() {
                let that = this;
                let parm = {
                    Code: that.dataDetail.Head.order_no
                };
                that.btn.Balance = false
                that.$http.urlpost('/Pur/GRN/GetPurReceiveInKeepAccount', parm, function (res) {
                    that.btn.Balance = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_No);
                    }
                });
            },
            
            checkDataChange(){
                let that = this
                //能打开此页面即拥有保存权限
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.List.length;i++){
                    delete datacopy.List[i]['index']
                    delete datacopy.List[i]['_XID'];
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
            // 排序
            sortChange(column){
                let that = this
                that.$processdata.sortChangeVxe(column,that.dataDetail.List)
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
